module.exports = __webpack_public_path__ + "static/unstructured-information-76b74f131931b0d605f71dda05ceee25.png";